export default "__VITE_ASSET__DGm$QFem__"